import { useSelector } from 'react-redux';

import { Box } from 'components/Box';
import { LoadingIndicator } from 'components/LoadingIndicator';
import { TileCarousel } from 'components/TileCarousel';
import { useRecommendedActions } from 'hooks/useRecommendedActions';
import { CmsApiRecommendedActionsBlockData } from 'modules/cms/api/types/blocks/CmsApiRecommendedActionsBlock';
import { MainStoreState } from 'modules/main/store';
import { listingSearchHomePath } from 'utils/searchHomePages';

type Props = {
  data: CmsApiRecommendedActionsBlockData;
};

export function CmsRecommendedActionsBlock({
  data: { headline, volopFunction, areaOfFocus },
}: Props) {
  const searchLocation = useSelector<MainStoreState>(
    (state) => state.mainSearch.searchLocation,
  ) as SearchLocation;

  const { data: recommendedActions, isLoading } = useRecommendedActions(
    searchLocation,
    {
      volopFunction,
      areaOfFocus,
    },
  );

  if (isLoading) return <LoadingIndicator />;

  const additionalAnalyticsProps: Record<string, string> = {};

  if (volopFunction) additionalAnalyticsProps.volop_function = volopFunction;
  if (areaOfFocus) additionalAnalyticsProps.area_of_focus = areaOfFocus;

  return (
    <Box
      data-qa-id="recommended-actions"
      data-qa-volop-function={volopFunction}
      data-qa-area-of-focus={areaOfFocus}
    >
      <TileCarousel
        headline={headline}
        results={recommendedActions}
        seeAllText={
          /* TRANSLATORS: Link to actions search */
          getText('See All Volunteer Opportunities')
        }
        seeAllUrl={listingSearchHomePath('VOLOP')}
        listingType="ACTION"
        additionalAnalyticsProps={additionalAnalyticsProps}
      />
    </Box>
  );
}
